import { type FunctionComponent, useState } from 'react';
import { onLeftButtonClick, onRightButtonClick } from '../../../../helpers/carousel/carousel.helper';
import { CarouselButtonsWithCount } from '../../../carousel-components/carousel-buttons-with-count/carousel-buttons-with-count.component';
import { HomeShopByLookPanel } from '../common/shop-by-look-panel.component';
import { ShopByLookSlide, ShopByLookImageSlide } from '../common/shop-by-look-slide.component';
import { textSliderContainer, transitionStyle, cardSliderContent } from './shop-by-look.css';
import { type HomeShopByLookSizedProps } from './shop-by-look.types';

export const HomeShopByLookLarge: FunctionComponent<HomeShopByLookSizedProps> = ({ className, slides }) => {
	const [activeIndex, setActiveIndex] = useState(0);
	const [translateValuePercentageCard, setTranslateValuePercentageCard] = useState(0);

	return (
		<div className={`${className} chromatic-ignore`} data-testid="home-shop-by-look-large">
			<HomeShopByLookPanel>
				<div className="z-2">
					{/* TextSlider */}
					<div className={`relative overflow-hidden ${textSliderContainer}`}>
						<div
							className={`flex h-100 ${transitionStyle}`}
							style={{
								transform: `translate(${translateValuePercentageCard}%)`,
								scrollBehavior: 'smooth',
								touchAction: 'pan-y'
							}}
							data-testid="shop-by-look-large-text-slider">
							{slides.map((slide, index) => (
								<div className={`flex ${cardSliderContent}`} key={`${slide.title}-${index}`}>
									<ShopByLookSlide item={slide} />
								</div>
							))}
						</div>
					</div>
					<CarouselButtonsWithCount
						onLeftButtonClick={() => onLeftButtonClick(setTranslateValuePercentageCard, setActiveIndex, activeIndex)}
						onRightButtonClick={() => onRightButtonClick(setTranslateValuePercentageCard, setActiveIndex, activeIndex)}
						activeIndex={activeIndex}
						totalItems={slides.length}
						className="theme-white justify-start"
					/>
				</div>
			</HomeShopByLookPanel>
			{/* ImageSlider */}
			<div className="relative overflow-hidden">
				<div
					className={`flex h-100 ${transitionStyle}`}
					data-testid="shop-by-look-large-image-slider"
					style={{
						transform: `translate(${translateValuePercentageCard}%)`,
						scrollBehavior: 'smooth',
						touchAction: 'pan-y'
					}}>
					{slides.map((slide, index) => (
						<div className={`flex ${cardSliderContent}`} key={`${slide.title}-${index}`}>
							<ShopByLookSlide item={slide} SlideContent={ShopByLookImageSlide} />
						</div>
					))}
				</div>
			</div>
		</div>
	);
};
